import { ViewFactory } from 'wdc-cube-react'
import { WaitingScope } from '../Waiting.scopes'
import { WaitingView } from './Waiting.view'

export function registerViews(rv = ViewFactory.register) {
    rv(WaitingScope, WaitingView)
}
